/* eslint-disable */
import React from "react";
import { Row, Col, Carousel, Typography } from "antd";
import "./bannerimage.css";
import { useBreakpoints } from "./ResponsiveBreakPoints";

const BannerImage = () => {
  const { isSuperLarge } = useBreakpoints();

  const slides = [
    {
      title: "36 years of Trusted Real Estate guidance, turning property decisions into Peace of Mind.",
      subtitle:
        "Shree Vastu Management & Developers",
    },
    {
      title: "Taking care of your Real Estate needs is what we do best",
      subtitle:
        "We provide a complete service for the sale, purchase or rental of real estate.",
    },
    {
      title: "Your trusted partner in every real estate move.",
      subtitle:
        "From buying and selling to leasing and investment advice — we handle it all with expertise and care.",
    },
    {
      title: "Making property dreams a reality.",
      subtitle:
        "We specialize in end-to-end real estate solutions — residential, commercial, and rental — tailored to your goals.",
    },
  ];

  return (
    <Row className="caraousalContainer">
      <Col
        xs={22}
        sm={22}
        md={22}
        lg={18}
        xl={20}
        xxl={16}
        className="fontContainer"
        style={{ maxWidth: isSuperLarge ? "50%" : "" }}
      >
        <Carousel autoplay autoplaySpeed={6500} speed={1600} dots={false}>
          {slides.map((slide, index) => (
            <div key={index} className="carouselSlide">
              <Typography className="carouselTitle">{slide.title}</Typography>
              <Typography className="carouselSubtitle">
                {slide.subtitle}
              </Typography>
            </div>
          ))}
        </Carousel>
      </Col>
    </Row>
  );
};

export default BannerImage;
